const PageEnums = Object.freeze({
  INTRO: 'INTRO',
  SETTINGS: 'SETTINGS',
  PRIVACY: 'PRIVACY',
  PROCESSING: 'PROCESSING',
  REJECT_SUCCESS: 'REJECT_SUCCESS',
  ACCEPT_SUCCESS: 'ACCEPT_SUCCESS',
  ACCEPT_FAIL: 'ACCEPT_FAIL',
});

const SectionEnums = Object.freeze({
  CHECK: 'CHECK',
  PERMISSION: 'PERMISSION',
});

export { PageEnums, SectionEnums };
